// React Imports
import * as React from "react";
import {useDispatch, useSelector} from "react-redux";


// Mui Imports
import MenuItem from "@mui/material/MenuItem";
import {
    ListItemIcon,
    ListItemText,
    Tooltip
} from "@mui/material";


// App Imports

import Box from "@mui/material/Box";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import {contractUpdate} from "../../../Contract/ContractClient";
import {changeWorkQueue} from "../../workQueueSlice";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";


// main function
export default function UnTagContract({ onMenuClose, rowContractData, selectorContractList }) {

    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************

    const currentUserName = localStorage.getItem('userName');
    const contractArray = useSelector((state) => state.workQueueSlc.value.mousedContractContractIdArray);


    // const handleUnTag = () => {
    //     onMenuClose();
    //     updateStatusByContractList(selectorContractList, 'Unapproved')
    //         .then(() => {
    //             dispatchData(changeWorkQueue({workQueueCGridRefresh: true}));
    //         });
    // };

    const handleUnTag = () => {
        onMenuClose();
        contractUpdate(contractArray, [], [],'Update Status',
            '2033', null, currentUserName, true)
            .then(() => {
                dispatchData(changeWorkQueue({workQueueCGridRefresh: true}));
            });
    };


    return (

        <Box>
            {(rowContractData.contractLevel === "Series" ||
                    rowContractData.contractLevel === "Season" ||
                    rowContractData.contractLevel === "Residuals" ||
                    rowContractData.contractLevel === "Property" ||
                    rowContractData.contractLevel === "Labor Group" ||
                    (rowContractData.contractLevel === "Guild" && rowContractData.contractStatus === "Tagged")) &&
                <MenuItem onClick={handleUnTag}>
                    <ListItemIcon>
                        <BookmarkBorderIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Un-Tag</ListItemText>
                </MenuItem>}
        </Box>

    )

}
